<template>
  <md-list-item :class="!accountBlocked ? 'active' : 'disabled' + ' account-seed'" @click="toggleItem">

    <span class="settings__item-text text_large">{{ i18n.set_secret_seed() }}</span>
    <md-icon class="md-icon--half-sized">keyboard_arrow_right</md-icon>

    <md-dialog class="settings-seed__dialog settings-dialog" :md-active.sync="isDialogOpened">
      <div class="text_large">{{ i18n.set_copy_secret_seed() }}</div>

      <div class="settings-dialog__content">
        <p class="settings-dialog__description text_medium">{{ i18n.set_seed_description() }}</p>
        <clipboard-field :value="accountSeed"/>
      </div>

      <div class="btn-wrap margin-top">
        <md-button type="button" class="btn md-primary" @click="isDialogOpened = !isDialogOpened">{{ i18n.lbl_cancel() }}</md-button>
      </div>

    </md-dialog>
  </md-list-item>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'

  import ClipboardField from '@com/fields/ClipboardField'

  export default {
    name: 'account-seed',
    components: { ClipboardField },
    data: _ => ({
      isDialogOpened: false,
      i18n
    }),
    methods: {
      toggleItem () {
        if (!this.accountBlocked) this.isDialogOpened = !this.isDialogOpened
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountSeed,
        vuexTypes.accountBlocked
      ])
    }
  }
</script>

<style lang="scss" scoped>
  @import './settings.scss';


</style>



// WEBPACK FOOTER //
// src/vue/app/settings/security/Security.Seed.vue